import { isMobile as isMobileFromLib } from "react-device-detect";

export const isMobile = isMobileFromLib;
// export const isMobile = true;

export const isDarkMode =
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;
